// extracted by mini-css-extract-plugin
module.exports = {"header":"L2Carousel_header__1GSks","skeletonRow":"L2Carousel_skeletonRow__ZXTt8","skeletonCard":"L2Carousel_skeletonCard__Pjy6N"};